/**
 * Styled Components - Created by miguelcanobbio on 25/07/18.
 */
import Icon from 'antd/lib/icon'
import Popover from 'antd/lib/popover'
import styled from 'styled-components'
import {
  GRAY_DARK,
  GRAY_LIGHTEST,
  RED,
  WHITE
} from '../../../theme/colors'

interface StyledProps {
  showTooltips?: boolean
}

interface ExtProps {
  color?: string
}

export const Container = styled.div`
  width: 220px;
  display: flex;
  flex-direction: column;
  position: relative;
  @media (min-width: 388px) and (max-width: 467px) {
    width: 160px;
  }

  @media (min-width: 320px) and (max-width: 387px) {
    width: 145px;
  }
`

export const Image = styled.img`
  width: 220px;
  height: 220px;
  object-fit: contain;
  background-color: ${GRAY_LIGHTEST};

  @media (min-width: 388px) and (max-width: 467px) {
    width: 160px;
    height: 160px;
  }
  @media (min-width: 320px) and (max-width: 387px) {
    width: 145px;
    height: 145px;
  }
  &:hover {
    cursor: pointer;
    box-shadow: 0px 2px 7px -1px #9d9d9d;
  }
`

export const Bottom = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 4px;
`

export const Name = styled.div`
  color: ${GRAY_DARK};
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
  margin-right: 4px;
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  @media (min-width: 320px) and (max-width: 467px) {
    font-size: 14px;
  }
`

export const Delete = styled.div`
  color: ${RED};
  font-size: 14px;
  letter-spacing: 0.1px;
  line-height: 23px;
  cursor: pointer;
`

export const LowQualityIcon = styled.img`
  position: absolute;
  width: 50px;
  right: 5px;
  top: 5px;
  z-index: 8;
  &:hover {
    cursor: pointer;
  }
  ${({ showTooltips }: StyledProps) => showTooltips ? `
    animation: pulse 2s 2s infinite;
    @keyframes pulse {
      0% {
        transform: scale(0.95);
        filter: drop-shadow(0 0 0 rgba(255, 0, 0, 1));
      }
    
      70% {
        transform: scale(1);
        filter: drop-shadow(0 0 10px rgba(255, 0, 0, 0));
      }
    
      100% {
        transform: scale(0.95);
        filter: drop-shadow(0 0 0 rgba(255, 0, 0, 0));
      }
    }
  ` : ''}
`

export const InfoIcon = styled.img`
  height: 28px;
  position: absolute;
  right: -9px;
  top: -13px;
  z-index: 9;
  filter: brightness(140%) saturate(200%) drop-shadow(0px 2px 2px ${GRAY_DARK});
  animation: wobble-hor-bottom 1s 1s 4 both;
  @keyframes wobble-hor-bottom {
    0%, 20%, 50%, 80%, 100% {transform: translateY(0);}
    40% {transform: translateY(-15px);}
    60% {transform: translateY(-7px);}
  }
`

export const ImportedIcon = styled(Icon)`
  font-size: 12px;
  position: absolute;
  left: 7px;
  top: -9px;
  transform: rotate(-90deg);
  background: white;
  color: #7c61b4;
  border-radius: 25px;
  padding: 4px;
  border: 1px solid #ece3ff;
  box-shadow: none;
`

export const StyledTooltip = styled(Popover)``

export const TooltipContent = styled.div`
  max-width: 398px;
`

export const TooltipContentModal = styled.div`
  max-width: 398px;
  margin-bottom: 12px;
  margin-left: -38px;
`

export const StatusIcon = styled.img`
  float: right;
  max-width: 78px;
  margin-left: 8px;
`

export const TooltipBody = styled.div`
  padding-top: 16px;
  padding-left: 8px;
  padding-right: 10px;
  @media (max-width: 767px) {
    padding-top: 30px;
    padding-left: 19px;
    padding-right: 17px;
  }
`

export const buttonStyle = {
  boxShadow: 'none',
  border: 'none',
  background: 'none',
  color: RED
}

export const ExtLabel = styled.div`
  background-color: ${({ color = GRAY_DARK }: ExtProps) => color};
  position: absolute;
  right: 0;
  bottom: 40px;
  padding: 4px 20px;
  border-bottom-left-radius: 5px;
  border-top-left-radius: 5px;
  color: ${WHITE};
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
`

export const CreatedAtLabel = styled.div`
  position: absolute;
  bottom: 54px;
  font-size: 11px;
  left: 0;
  background: #ffffff80;
  padding-left: 8px;
  border-radius: 3px;
  padding-right: 4px;
  font-family: Avenir;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0;
  color: #646464;
`

export const DocIcon = styled(Icon)`
  width: 220px;
  height: 220px;
  align-items: center;
  justify-content: center;
  display: flex;
  font-size: 27px;
  color: ${GRAY_DARK};
  background: ${GRAY_LIGHTEST};
  transition: all .25s;
  &:hover {
    cursor: pointer;
    box-shadow: 0px 2px 7px -1px #9d9d9d;
  }
  &:last-child {
    margin-right: 0;
  }
`

export const LogoImage = styled.img`
  width: 220px;
  height: 220px;
  align-items: center;
  justify-content: center;
  display: flex;
  font-size: 24px;
  color: ${GRAY_DARK};
  background: ${GRAY_LIGHTEST};
  padding: 30%;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    box-shadow: 0px 2px 7px -1px #9d9d9d;
  }
  &:last-child {
    margin-right: 0;
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/MyFiles/ImageItem/styledComponents.tsx